<label class="textColour">Participants</label>

<div *ngIf="!participants?.length">No participants</div>

<div class="list" *ngIf="participants?.length">
    

  <div class="user-card" *ngFor="let user of participants">

    <div 
  class="avatar"
  [ngStyle]="{ 'background-color': getAvatarColor(user.firstname) }"
>
      {{ getInitials(user) }}
    </div>

    <div class="details">
      <div class="name">
        {{ user.firstname }} {{ user.lastname }}
      </div>
      <div class="email">
        {{ user.useremail }}
      </div>
    </div>

  </div>
</div>